module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sekundaerlogo_postale_troendelag_neg.627c01d9.pdf";